import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const StBigLogo = styled.img`
  max-height: ${({ theme }) => theme.UI.SpacingPx.Space10};
  object-fit: contain;

  @media ${breakpoints.fromS} {
    height: ${({ theme }) => theme.UI.SpacingPx.Space12};
    max-height: none;
  }
`

export { StBigLogo }
